import React from "react"
import PropTypes from 'prop-types';
import { Circles } from "react-loader-spinner";

function FormLoader({ loading }) {
    return (
        loading ?
            //<div style={{ textAlign: "center", marginTop: "250px" }}>
            //    <Oval color="#00BFFF" height={80} width={80} />
            //</div >
            <Circles color="#00BFFF" height={80} width={80} />
           
            :
            /*<div></div>*/
            <div style={{ textAlign: "center", marginTop: "250px" }}>
               
            </div >
    )
};

FormLoader.propTypes = {
    loading: PropTypes.bool
}

export default FormLoader
